import { IOrganizationRepository, IPlanRepository } from '../../domain/repositories/IOrganizationRepository';
import { IInvoiceRepository } from '../../domain/repositories/IInvoiceRepository';
import { OrganizationHttpRepository } from '../repositories/OrganizationHttpRepository';
import { PlanHttpRepository } from '../repositories/PlanHttpRepository';
import { InvoiceHttpRepository } from '../repositories/InvoiceHttpRepository';
import { getApiPrefix } from '@shared/infrastructure/getApiPrefix';

export class OrganizationDependencyContainer {
  private static organizationRepository: IOrganizationRepository;
  private static planRepository: IPlanRepository;
  private static invoiceRepository: IInvoiceRepository;

  static getOrganizationRepository(): IOrganizationRepository {
    return this.organizationRepository ?? new OrganizationHttpRepository(getApiPrefix());
  }

  static setOrganizationRepository(repository: IOrganizationRepository): void {
    this.organizationRepository = repository;
  }

  static getPlanRepository(): IPlanRepository {
    return this.planRepository ?? new PlanHttpRepository();
  }

  static setPlanRepository(repository: IPlanRepository): void {
    this.planRepository = repository;
  }

  static getInvoiceRepository(): IInvoiceRepository {
    return this.invoiceRepository ?? new InvoiceHttpRepository();
  }

  static setInvoiceRepository(repository: IInvoiceRepository): void {
    this.invoiceRepository = repository;
  }

  static reset(): void {
    this.organizationRepository = null as unknown as IOrganizationRepository;
    this.planRepository = null as unknown as IPlanRepository;
    this.invoiceRepository = null as unknown as IInvoiceRepository;
  }
}
